import PaymentSettings from './PaymentSettings';

export default PaymentSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/PaymentSettings/index.tsx